/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CompanyUserServiceLevelBase', 'model/CompanySubscriptionReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/CompanyUserServiceLevelBase'), require('../model/CompanySubscriptionReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CompanySubscriptionReportApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CompanyUserServiceLevelBase, root.ForStractionServiceApi.CompanySubscriptionReport);
  }
}(this, function(ApiClient, CompanyUserServiceLevelBase, CompanySubscriptionReport) {
  'use strict';

  /**
   * CompanySubscriptionReport service.
   * @module api/CompanySubscriptionReportApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new CompanySubscriptionReportApi. 
   * @alias module:api/CompanySubscriptionReportApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the companySubscriptionReportDisableCompanySubscriptionLevelGet operation.
     * @callback module:api/CompanySubscriptionReportApi~companySubscriptionReportDisableCompanySubscriptionLevelGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * disableCompanySubscriptionLevel
     * @param {String} _4SAPIAppID 
     * @param {Integer} subscriptionLevelID 
     * @param {module:api/CompanySubscriptionReportApi~companySubscriptionReportDisableCompanySubscriptionLevelGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.companySubscriptionReportDisableCompanySubscriptionLevelGet = function(_4SAPIAppID, subscriptionLevelID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companySubscriptionReportDisableCompanySubscriptionLevelGet";
      }

      // verify the required parameter 'subscriptionLevelID' is set
      if (subscriptionLevelID == undefined || subscriptionLevelID == null) {
        throw "Missing the required parameter 'subscriptionLevelID' when calling companySubscriptionReportDisableCompanySubscriptionLevelGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'subscriptionLevelID': subscriptionLevelID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CompanySubscriptionReport/disableCompanySubscriptionLevel', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the companySubscriptionReportEditAllUserServiceLevelsPut operation.
     * @callback module:api/CompanySubscriptionReportApi~companySubscriptionReportEditAllUserServiceLevelsPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAllUserServiceLevels
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/CompanyUserServiceLevelBase>} body 
     * @param {module:api/CompanySubscriptionReportApi~companySubscriptionReportEditAllUserServiceLevelsPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.companySubscriptionReportEditAllUserServiceLevelsPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companySubscriptionReportEditAllUserServiceLevelsPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling companySubscriptionReportEditAllUserServiceLevelsPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CompanySubscriptionReport/editAllUserServiceLevels', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the companySubscriptionReportLoadGet operation.
     * @callback module:api/CompanySubscriptionReportApi~companySubscriptionReportLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CompanySubscriptionReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {module:api/CompanySubscriptionReportApi~companySubscriptionReportLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CompanySubscriptionReport}
     */
    this.companySubscriptionReportLoadGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companySubscriptionReportLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = CompanySubscriptionReport;

      return this.apiClient.callApi(
        '/CompanySubscriptionReport/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the companySubscriptionReportSetCompanySubscriptionLevelGet operation.
     * @callback module:api/CompanySubscriptionReportApi~companySubscriptionReportSetCompanySubscriptionLevelGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setCompanySubscriptionLevel
     * @param {String} _4SAPIAppID 
     * @param {Integer} subscriptionLevelID 
     * @param {module:api/CompanySubscriptionReportApi~companySubscriptionReportSetCompanySubscriptionLevelGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.companySubscriptionReportSetCompanySubscriptionLevelGet = function(_4SAPIAppID, subscriptionLevelID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companySubscriptionReportSetCompanySubscriptionLevelGet";
      }

      // verify the required parameter 'subscriptionLevelID' is set
      if (subscriptionLevelID == undefined || subscriptionLevelID == null) {
        throw "Missing the required parameter 'subscriptionLevelID' when calling companySubscriptionReportSetCompanySubscriptionLevelGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'subscriptionLevelID': subscriptionLevelID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CompanySubscriptionReport/setCompanySubscriptionLevel', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
